import React, { useEffect, useState } from "react";

// JS Files

// Others File

const GuideSteps = () => {
  return (
    <>
      <div className="flex flex-col md:col-span-4 border-b md:border-b-0 md:border-l md:border-dashed pb-4 md:pb-0 px-2">
        <span className="font-bold text-sm md:text-lg md:mb-4 mb-2">
          مراحل ثبت‌نام بیمه درمان تکمیلی:
        </span>
        <div className="flex items-center my-2 text-xs md:text-sm">
          <div className="bg-myorange-500 p-2 md:p-4 rounded-full w-6 h-6 flex justify-center items-center">
            <span className="text-white">1</span>
          </div>
          <span className="mr-2">
            احراز هویت از طریق وارد کردن شماره‌همراه و دریافت کد یک‌بار مصرف (اگر قبلا احراز هویت را انجام داده‌اید، روی دکمه تایید و ادامه کلیک کنید.)
          </span>
        </div>
        <div className="flex items-center my-2 text-xs md:text-sm">
        <div className="bg-myorange-500 p-2 md:p-4 rounded-full w-6 h-6 flex justify-center items-center">
        <span className="text-white">2</span>
          </div>
          <span className="mr-2">تکمیل اطلاعات مربوط به بیمه‌شده اصلی</span>
        </div>
        <div className="flex items-center my-2 text-xs md:text-sm">
        <div className="bg-myorange-500 p-2 md:p-4 rounded-full w-6 h-6 flex justify-center items-center">
        <span className="text-white">۳</span>
          </div>
          <span className="mr-2">
            بارگذاری تصویر پشت و رو کارت ملی و صفحات اول، دوم، سوم شناسنامه
            بیمه‌شده اصلی
          </span>
        </div>
        <div className="flex items-center my-2 text-xs md:text-sm">
        <div className="bg-myorange-500 p-2 md:p-4 rounded-full w-6 h-6 flex justify-center items-center">
        <span className="text-white">۴</span>
          </div>
          <span className="mr-2">افرودن و تکمیل اطلاعات افراد تحت تکفل به همراه بارگذاری صفحه اول و دوم شناسنامه</span>
        </div>
        <div className="flex items-center my-2 md:my-2 text-sm text-red-500">
          <span className="mr-2">کاربر گرامی، رفاپ هیچ‌گونه مسئولیتی برای صحت سنجی اطلاعات وارد شده ندارد و کلیه اطلاعات باید توسط بیمه‌شده اصلی (کاربری که احزار هویت کرده است) به درستی وارد شود.</span>
        </div>
      </div>
    </>
  );
};
export default GuideSteps;
